import React, { useEffect, useState } from 'react'
import { Row, Col, Image, Layout, Typography } from 'antd'
import logo from '../../logo.png'
import PatientInfoForm from '../../component/patient/patient.info.form'
import ConsentFomrms from './consent'
import Review from './review'
import { getConsentForm } from '../../store/action/patient.action'
import { getCustomerLogoAndName } from '../../store/action/customer.action'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import ThankYou from './thankyou'
import util from '../../util/util'

const { Title } = Typography
const { Content, Footer } = Layout
const PatientRegistration = (props) => {
  const [currentStep, setCurrentStep] = useState(1)
  const [registerationState, setRegisterationState] = useState({})
  const [consentForms, setConsentForms] = useState([])
  const [customerData, setCustomerData] = useState({})
  const params = useParams()
  const customerid = params.customer_id
  useEffect(() => {
    window.scrollTo(0, 0)
    ;(async () => {
      const customerData = await props.getCustomerLogoAndName(customerid)
      setCustomerData(customerData)
      const response = await props.getConsentForm(customerid)
      setConsentForms(response)
    })()
  }, [])
  const renderPatientRegistration = () => {
    return (
      <Row>
        <Col className='patientAddContainer' flex={'100%'}>
          <PatientInfoForm
            patient={registerationState.patient}
            customer={customerData}
            isRegistration={true}
            setNewRegistrationPatient={(newPatient) => {
              setRegisterationState((prev) => ({
                ...prev,
                patient: newPatient,
              }))
              setCurrentStep(2)
            }}
          />
        </Col>
      </Row>
    )
  }
  const renderConsentForms = () => {
    return (
      <ConsentFomrms
        navigateBack={() => setCurrentStep(1)}
        navigateNext={() => setCurrentStep(3)}
        setConsentState={(consentState, checkedStates) =>
          setRegisterationState((prev) => ({
            ...prev,
            consent: consentState,
            checkedStates,
          }))
        }
        registerationState={registerationState}
        consentForms={consentForms}
      />
    )
  }
  const renderReview = () => {
    return (
      <Review
        navigateBack={() => setCurrentStep(2)}
        registerationState={registerationState}
        consentForms={consentForms}
        onSubmit={() => {
          setRegisterationState({})
          setCurrentStep(4)
        }}
      />
    )
  }
  const renderThankYou = () => {
    return <ThankYou />
  }
  return (
    <Layout
      style={{
        padding: '0 0 0 0',
        height: '100vh',
        backgroundColor: '#DDDDDD',
      }}
    >
      <Content style={{ overflow: 'auto', background: 'white' }}>
        <center>
          {customerData?.logo ? (
            <Image
              src={customerData.logo}
              height={60}
              style={{ marginTop: 10 }}
            ></Image>
          ) : customerData?.name ? (
            <Title level={2}>{customerData.name}</Title>
          ) : (
            ''
          )}
          {customerData && <Title level={4}>PATIENT AUTHORIZATION FORM</Title>}
        </center>
        {customerData && (
          <div className='patientRegistrationContainer'>
            {currentStep == 1 && renderPatientRegistration()}
            {currentStep == 2 && renderConsentForms()}
            {currentStep == 3 && renderReview()}
            {currentStep == 4 && renderThankYou()}
          </div>
        )}
      </Content>
      <Footer className='main-footer'>{util.getCopyrightText()}</Footer>
    </Layout>
  )
}
const mapStateToProps = (state) => {
  return {}
}
const mapDispatchToProps = (dispatch) => {
  return {
    getConsentForm: (input) => dispatch(getConsentForm(input)),
    getCustomerLogoAndName: (input) => dispatch(getCustomerLogoAndName(input)),
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(PatientRegistration)
